import { Modal } from 'antd'

export const confirmDiscardChanges = (): Promise<boolean> =>
  new Promise(resolve => {
    Modal.confirm({
      title: 'Несохранённые изменения',
      content: 'Изменённые данные не будут сохранены. Продолжить?',
      okText: 'Да',
      cancelText: 'Отмена',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    })
  })
